/**
 * @file Configuration des rôles et de leurs libellés d'affichage.
 * @module packages.common.utils.rolesConfig
 *
 * Les rôles plateforme représentent un niveau d'accès au panel admin :
 * APP_ADMIN a un accès implicite total, APP_COLLABORATOR n'accède qu'à ce que
 * ses permissions (session.adminAccess, cf. config/adminSections) lui
 * accordent. Le métier d'un collaborateur (commercial, partenaire) est une
 * étiquette de profil, pas un rôle.
 */

import {paths} from 'packages/common/routes/paths';

export const roles = {
  APP_ADMIN: 'AppAdmin',
  APP_COLLABORATOR: 'AppCollaborator',
  COMPANY_ADMIN: 'CompanyAdmin',
  COMPANY_USER: 'CompanyUser',
};

export const roleLabels = {
  [roles.APP_ADMIN]: 'Super Admin',
  [roles.APP_COLLABORATOR]: 'Collaborateur',
  [roles.COMPANY_ADMIN]: 'Administrateur',
  [roles.COMPANY_USER]: 'Utilisateur',
};

/** Libellés des profils métier des collaborateurs du panel admin. */
export const adminProfileLabels = {
  commercial: 'Commercial',
  partner: 'Partenaire',
  custom: 'Personnalisé',
};

export const routeRoles = {
  [paths.admin.root]: [roles.APP_ADMIN, roles.APP_COLLABORATOR],
  [paths.app.root]: [roles.COMPANY_ADMIN, roles.COMPANY_USER],
};

/**
 * Vérifie si le rôle fourni a accès à la route spécifiée
 *
 * @param {string} role - Rôle de l'utilisateur
 * @param {string} route - Route à vérifier
 * @return {boolean} True si l'utilisateur a accès
 */
export const checkAccess = (role, route) => {
  return routeRoles[route]?.includes(role);
};

/**
 * Convertit le rôle technique en libellé lisible pour affichage
 *
 * @param {string} role - Rôle technique (AppAdmin, AppCollaborator, etc.)
 * @return {string} Libellé du rôle pour affichage utilisateur
 */
export const getRoleLabel = (role) => {
  return roleLabels[role] || 'Utilisateur';
};

/**
 * Libellé du profil métier d'un collaborateur.
 *
 * @param {string} profile - Profil technique (commercial, partner, custom)
 * @return {string} Libellé pour affichage
 */
export const getAdminProfileLabel = (profile) => {
  return adminProfileLabels[profile] || adminProfileLabels.custom;
};
